import { Button, DatePicker, message, Row, Table } from 'antd';
import FileSaver from "file-saver";
import { inject, observer } from "mobx-react";
import moment from 'moment';
import React, { Component } from 'react';
import Auth from "@/components/table/Auth";
import { columns, compute, } from "./compute";
import request from "@/method/axios";
import _ from 'lodash';
@inject('store')
@observer
class index extends Component {
    state = {
        date: moment().format('YYYY-MM-DD'),
        data: [],
        loading: true,
        loadingSave: false,
        print: false,
        key: "daily_warn"
    }

    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data, key) => {
        data = compute(data);
        this.setState({ [key]: data, loading: false, });
    }
    onChange = (name, value, i, key = "talbe1") => {
        let data = this.state[key];
        data[i][name] = value;
        this.computeNum(data, key);
    }

    getData = async (date) => {
        try {
            this.setState({ loading: true, data: [] });
            const res = await request.get('/api/daily1_5', {
                params: {
                    date
                }
            });
            this.setState({
                data: res.data, loading: false
            })
        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
        }
    }


    downloadExcel = (id) => {
        const tableName = `${this.state.date} 1.5 每日经营报表报警记录`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById(id).innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, date, print, loading, key } = this.state;

        return (
            <div className="table7_1_1 tableHeight">
                <Row className="title" id="view4_1_4"   >
                    <Row>1.5 每日经营报表报警记录</Row>
                    <Row className="table-month">
                        <DatePicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            defaultValue={moment(date, "YYYY-MM-DD")}
                            format="YYYY-MM-DD"
                            onChange={(date, str) => {
                                this.getData(date)
                            }}
                        />
                    </Row>
                    <Table
                        columns={columns(() => { }, date, print)}
                        dataSource={data}
                        size="middle"
                        id="table1"
                        bordered
                        loading={loading}
                        pagination={false}
                        rowClassName="protruding"
                        className="content"
                        scroll={print ? {} : { y: 500 }}
                        rowKey={(record, index) => index}
                    />
                    {!print && <Button
                        type="primary"
                        style={{ marginTop: 20, marginLeft: "calc(100% - 200px)" }}
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel('table1');
                            });
                        }}
                        loading={print}
                    >导出Excel</Button>}
                </Row>
            </div >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.5/index.js